// extracted by mini-css-extract-plugin
export default {"notesContainer":"CareComponentNotes_notesContainer__qXhAi"};